/**
 * Debt & Financial Legal Issues hub — global subcategory registry.
 */
import {
  DEBT_FINANCIAL_LEGAL_SLUG,
  debtFinancialLegalDefaultData,
} from "./debtFinancialLegalData";
import {
  DebtFinancialLegalArticlesTab,
  DebtFinancialLegalMediaTab,
  DebtFinancialLegalOverviewTab,
} from "./DebtFinancialLegalDesign";

export const debtFinancialLegalModule = {
  slug: DEBT_FINANCIAL_LEGAL_SLUG,
  getDefaultData: () => debtFinancialLegalDefaultData,
  Views: {
    overview: DebtFinancialLegalOverviewTab,
    articles: DebtFinancialLegalArticlesTab,
    media: DebtFinancialLegalMediaTab,
  },
};
